import React from 'react'


class StepTab extends React.Component {
    render() {
        const {step, clickHandle} = this.props
        return(
            <div className="step-tab">
                <div className="step-tab-list">
                    <div className={`step-tab-item step-tab-item__left  ${step === 1 ? "step-tab-item__active" : ""}`} onClick={() => clickHandle(1)}>
                        <span className="step-tab-item__circle">1</span>
                        <p className="step-tab-item__text">选择授课方式</p>
                    </div>
                    <div className="step-tab-item step-tab-item-dist"/>
                    <div className="step-tab-item__line"/>
                    {step === 1 &&
                    <div className="step-tab-item__line step-tab-item__line-active"/>
                    }
                    <div className={`step-tab-item  ${step === 2 ? "step-tab-item__active" : ""}`} onClick={() => clickHandle(2)}>
                        <span className="step-tab-item__circle">2</span>
                        <p className="step-tab-item__text">设置基本信息</p>
                    </div>
                    <div className="step-tab-item step-tab-item-dist"/>
                    <div className="step-tab-item__line step-tab-item__line-second"/>
                    {step === 2 &&
                    <div className="step-tab-item__line step-tab-item__line-second step-tab-item__line-active"/>
                    }
                    <div className={`step-tab-item step-tab-item__right  ${step === 3 ? "step-tab-item__active" : ""}`} onClick={() => clickHandle(3)}>
                        <span className="step-tab-item__circle">3</span>
                        <p className="step-tab-item__text">设置课程权限</p>
                    </div>
                </div>

            </div>
        )
    }
}

export default StepTab


// WEBPACK FOOTER //
// ./src/components/lectureCreate/StepTab.js